import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=505c61a7&scoped=true"
import script from "./solution.vue?vue&type=script&lang=js"
export * from "./solution.vue?vue&type=script&lang=js"
import style0 from "./solution.vue?vue&type=style&index=0&id=505c61a7&prod&lang=css"
import style1 from "./solution.vue?vue&type=style&index=1&id=505c61a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c61a7",
  null
  
)

export default component.exports